import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui/button";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancelled() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="payment-cancelled-page">
      <div className="border border-white/10 bg-[#0A0A0A] p-10 max-w-lg w-full text-center">
        <XCircle size={56} weight="fill" className="text-[#E30613] mx-auto" />
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold mt-4">{t("payment.cancelled_tag")}</div>
        <h2 className="font-display text-3xl uppercase font-black mt-2">{t("payment.cancelled_title")}</h2>
        <p className="text-zinc-400 mt-3 text-sm">{t("payment.cancelled_message")}</p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/my-bookings">
            <Button className="bg-[#E30613] hover:bg-[#FF1A27] text-white uppercase tracking-[0.2em] font-bold rounded-none" data-testid="cancelled-go-bookings">
              {t("payment.my_bookings_btn")}
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="border-white/30 text-white uppercase tracking-[0.2em] font-bold rounded-none">
              {t("payment.explore_more")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
